import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IBookmarkInfo } from '../interfaces/bookmark-info';

@Injectable({
    providedIn: 'root',
})
export class BookmarkService {
    constructor(private _http: HttpClient) {}

    private serverUrl = 'https://' + window.location.host;
    private version = '0.5'; // TODO Get version dynamically
    private _url = (this.serverUrl + '/api/v{version}/bookmark').replace('{version}', this.version);

    changeLoanBookmarkStatus(
        loanNumber: string,
        snooze: boolean,
        bookmark: boolean
    ): Observable<number> {
        let result = this._http.post<number>(this._url + '/ChangeLoanBookmarkStatus', {
            LoanNumber: loanNumber,
            Bookmark: bookmark,
            Snooze: snooze,
        });
        return result;
    }

    getBookmarks(): Observable<IBookmarkInfo[]> {
        return this._http.get<IBookmarkInfo[]>(this._url + '/GetBookmarks');
    }

    getBookmarksJson(): Observable<string> {
        return this._http.get<string>(this._url + '/GetBookmarksJson');
    }

    getBookmarksByLoanNumber(loanNumber: string): Observable<IBookmarkInfo> {
        return this._http.post<IBookmarkInfo>(this._url + '/GetBookmarkByLoanNumber', {
            LoanNumber: loanNumber,
        });
    }
}
